import { useEffect, useState } from 'react';
import {
  registerSession,
  hasGenerated,
  isSubmitted,
  isSnoozed,
  ENGAGEMENT_THRESHOLD,
} from '@/components/feedback/feedbackStorage';

/**
 * Decides whether the proactive feedback modal is eligible to appear.
 *
 * Counts the current browser session once (`registerSession` is idempotent per
 * tab, so a remount of the tree is not a new visit). The modal becomes eligible
 * once the user has come back a few times AND has actually generated something —
 * asking someone who has not used the product yet only produces "не успел(а)
 * разобраться" reviews.
 *
 * Returns only eligibility — the host component owns timing (e.g. delay, route
 * gating) and snoozing on dismiss.
 */
export function useFeedbackPrompt(): boolean {
  const [eligible, setEligible] = useState(false);

  useEffect(() => {
    const count = registerSession();
    if (
      count >= ENGAGEMENT_THRESHOLD &&
      hasGenerated() &&
      !isSubmitted() &&
      !isSnoozed()
    ) {
      setEligible(true);
    }
  }, []);

  return eligible;
}
